/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { Redirect, useRouter, type RouteContext } from '@atlassian/react-resource-router';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';

const serviceDeskEmailNextGenRedirectOld = ({ match }: RouteContext): React.JSX.Element => {
	const { projectKey } = match.params;
	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
	return <Redirect to={url} />;
};

const ServiceDeskEmailNextGenRedirectNew = (): React.JSX.Element => {
	const [{ match }] = useRouter();
	const { projectKey } = match.params;
	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
	return <Redirect to={url} />;
};

export const ServiceDeskEmailNextGenRedirect: React.ComponentType<RouteContext> = componentWithFG(
	'nike_entrypoint_migration_batch_2',
	ServiceDeskEmailNextGenRedirectNew,
	serviceDeskEmailNextGenRedirectOld,
);

export default ServiceDeskEmailNextGenRedirect;
